const HYDRATE = "__NEXT_REDUX_WRAPPER_HYDRATE__";

export const types = {
  RESET_INIT_PAGE: 'INIT_PAGE/RESET_INIT_PAGE',
  INIT_PAGE: 'INIT_PAGE/INIT_PAGE',
  SET_INIT_PAGE_BEGINS: 'INIT_PAGE/SET_INIT_PAGE_BEGINS',
  SET_INIT_PAGE_SUCCESS: 'INIT_PAGE/SET_INIT_PAGE_SUCCESS',
  SET_INIT_PAGE_FAILURE: 'INIT_PAGE/SET_INIT_PAGE_FAILURE',
  SET_ERROR: 'SET_ERROR',
  SET_LOCATION: 'SET_LOCATION',
};
export const actions = {
  initPage: ({ dependencies }) => ({
    type: types.INIT_PAGE,
    payload: { dependencies },
  }),
  setLocation: (location) => ({
    type: types.SET_LOCATION,
    payload: location,
  }),
  setInitPageBegins: (location) => ({
    type: types.SET_INIT_PAGE_BEGINS,
    payload: location,
  }),
  setInitPageSuccess: () => ({ type: types.SET_INIT_PAGE_SUCCESS }),
  setInitPageFailure: (error) => ({
    type: types.SET_INIT_PAGE_FAILURE,
    payload: error,
  }),
  setError: (error) => ({ type: types.SET_ERROR, payload: error }),
  resetInitPage: () => ({
    type: types.RESET_INIT_PAGE,
  }),
};
const initialState = {
  fetching: false,
  loaded: false,
  handlingCode: 0,
  location: {},
};
function reducer(state = { ...initialState }, { type, payload }) {
  switch (type) {
    case HYDRATE: {
      const { initPage } = payload;
      return {
        ...state,
        ...initPage,
      };
    }
    case types.SET_INIT_PAGE_BEGINS:
      return {
        ...state,
        fetching: true,
        location: payload,
        handlingCode: 0,
      };
    case types.SET_LOCATION:
      return {
        ...state,
        location: payload,
      };
    case types.SET_INIT_PAGE_SUCCESS:
      return {
        ...state,
        init: false,
        fetching: false,
        loaded: true,
        handlingCode: 0,
      };
    case types.SET_INIT_PAGE_FAILURE:
      return {
        ...state,
        fetching: false,
        handlingCode: payload,
      };
    case types.SET_ERROR:
      return {
        ...state,
        fetching: false,
        handlingCode: payload,
      };
    case types.RESET_INIT_PAGE:
      return {
        ...state,
        fetching: false,
        loaded: false,
      };
    default:
      return {
        ...state,
      };
  }
}
export default reducer;
